import React, { useMemo } from 'react';
import {
  mergeClasses,
  ToggleButton,
} from '@fluentui/react-components';

export const ToggleButtons = ({
  options,
  optionsState,
  toggleSelectedOption,
  classes,
}) => {
  const selectedButtonClasses = classes && classes.selectedButton ? classes.selectedButton : '';
  const initialClasses = classes && classes.toggleButton ? classes.toggleButton : '';

  const buttons = useMemo(() => options.map(option => (
    <ToggleButton
      key={option.key}
      icon={option.icon}
      className={mergeClasses(option.key, optionsState && optionsState[option.key] ? selectedButtonClasses : initialClasses)}
      checked={(optionsState && optionsState[option.key]) || false}
      onClick={() => {
        if (toggleSelectedOption) {
          toggleSelectedOption(option.key);
        }
      }}
    >
      {option.text}
    </ToggleButton>
  )), [initialClasses, options, optionsState, selectedButtonClasses, toggleSelectedOption]);

  return (buttons);
};
